import { Component, OnInit } from '@angular/core';
import { BusinesscaseService } from './businesscase.service';
import { Router } from "@angular/router";
import { environment } from 'src/environments/environment.prod';
// import { Console } from 'console';

@Component({
  selector: 'app-businesscase',
  templateUrl: './businesscase.component.html',
  styleUrls: ['./businesscase.component.scss']
})
export class BusinesscaseComponent implements OnInit {
  cols: any[];
  businessLogData: any;
  irrData: any;
  irrNpvData: any;
  loading: boolean = true;
  sourceDropdownOptions: any[];
  selectedSource: string;
  selectedAction = '';
  irrGreaterhundred: any;
  irrGreatertwentyfive: any;
  email: any;

  constructor(private businesscaselogservice: BusinesscaseService, private router: Router,) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.getBusinessCaseData();
    this.getIrrData();
    this.getIrrNpvData();
    this.getIrrGrHundred();
    this.getIrrGrTwentyFive();

    this.sourceDropdownOptions = [
      { label: 'Sales> 100 Mn and Sales = 0', value: 'Sales> 100 Mn and Sales = 0' },
      { label: 'IRR = 0', value: 'IRR = 0' },
      { label: 'NPV+ and IRR-', value: 'NPV+ and IRR-' },
      { label: 'IRR > 100%', value: 'IRR > 100%' },
      { label: 'MFD = Genericized and IRR > 25%', value: 'MFD = Genericized and IRR > 25%' }
    ];

    this.selectedSource = 'Sales> 100 Mn and Sales = 0';
    this.onDropdownChange();
  }

  onDropdownChange() {
    if (this.selectedSource === 'Sales> 100 Mn and Sales = 0') {
      this.selectedAction = 'businessCase';
    } else if (this.selectedSource === 'IRR = 0') {
      this.selectedAction = 'irr';
    } else if (this.selectedSource === 'NPV+ and IRR-') {
      this.selectedAction = 'irrNpv';
    } else if (this.selectedSource === 'IRR > 100%') {
      this.selectedAction = 'irrhundred';
    } else if (this.selectedSource === 'MFD = Genericized and IRR > 25%') {
      this.selectedAction = 'irrtwentyfive';
    }
  }

  refreshData() {
    this.loading = true;
    switch (this.selectedAction) {
      case 'businessCase':
        this.getBusinessCaseData();
        break;
      case 'irr':
        this.getIrrData();
        break;
      case 'irrNpv':
        this.getIrrNpvData();
        break;
      case 'irrhundred':
        this.getIrrGrHundred();
        break;
      case 'irrtwentyfive':
        this.getIrrGrTwentyFive();
        break;
      default:
        console.error("Invalid action");
        break;
    }
  }

  getBusinessCaseData() {
    this.businesscaselogservice.getBusinessCaseLogData(this.email).subscribe((response) => {
      this.businessLogData = response["data"];
      console.log("resss", this.businessLogData);
      this.loading = false;

    });
  }

  redirectToBusinesscasePage(brand_name, nda, dosage) {
    // window.open(`http://localhost:4200/#/settings?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
    window.open(`${environment.ip}#/settings?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
    // window.open(`http://3.111.249.237/#/settings?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
  }

  getIrrData() {
    this.businesscaselogservice.getIrrLogData(this.email).subscribe((response) => {
      this.irrData = response["data"];
      console.log("resss", this.irrData);
      this.loading = false;

    });
  }

  redirectToIrrPage(brand_name, nda, dosage) {
    // window.open(`http://localhost:4200/#/settings?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
    window.open(`${environment.ip}#/settings?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
    // window.open(`http://3.111.249.237/#/settings?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
  }

  getIrrNpvData() {
    this.businesscaselogservice.getIrrNpvLogData(this.email).subscribe((response) => {
      this.irrNpvData = response["data"];
      console.log("resss", this.irrNpvData);
      this.loading = false;
    });
  }

  getIrrGrHundred() {
    this.businesscaselogservice.getIrrGrHundredData(this.email).subscribe((response) => {
      this.irrGreaterhundred = response["data"];
      console.log("resss", this.irrGreaterhundred);
      this.loading = false;
    });
  }

  getIrrGrTwentyFive() {
    this.businesscaselogservice.getIrrGrTwentyFiveData(this.email).subscribe((response) => {
      this.irrGreatertwentyfive = response["data"];
      console.log("resss", this.irrGreatertwentyfive);
      this.loading = false;
    });
  }

  redirectToIrrNpvPage(brand_name, nda, dosage) {
    // window.open(`http://localhost:4200/#/settings?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
    window.open(`${environment.ip}#/settings?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
    // window.open(`http://3.111.249.237/#/settings?brand_name=${brand_name}&nda=${nda}&dosage=${dosage}`, '_blank');
  }

}
